function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from "react";
import Button from "../../../Common/Button";
import useData from "./data";
import ReactGA from "react-ga4";
import { renderDate } from "../../../../utils/helpers";
// Clients and redux will be injected via props
import MdPlayCircleOutline from "@meronex/icons/md/MdPlayCircleOutline";
import EiPlay from "@meronex/icons/ei/EiPlay";
import ReactPlayer from "react-player";
import Modal from "../../../Common/Modal";
import GrClose from "@meronex/icons/gr/GrClose";
import { toast } from "react-toastify";
import SkeletonDeal from "../../../Common/Skeleton/SkeletonDeal";
import PhoneNumber from "../PhoneNumber";
import DealGalleryItem from "../DealGalleryItem";
import RedeemAnimation from "../RedeemButtonAnimation";
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import SiWhatsapp from "@meronex/icons/si/SiWhatsapp";
import FaFacebookF from "@meronex/icons/fa/FaFacebookF";
import FiCopy from "@meronex/icons/fi/FiCopy.js";
import MdcEmailOutline from "@meronex/icons/mdc/MdcEmailOutline";
import EnShareAlternative from "@meronex/icons/en/EnShareAlternative";
import EiCloseO from "@meronex/icons/ei/EiCloseO";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DealEnquiry from "../../../DealEnquiry";
import BsArrowLeft from "@meronex/icons/bs/BsArrowLeft";
import { toIndianRs } from "../../../../utils/helpers";
import useKYC from "../../../../Hooks/use-KYC";
import KYCModal from "../../../Common/KYCModal";
import useBookingSummary from "../../../../Hooks/use-bookingSummary";
import RewardClaimDescription from "../RewardClaimDescription";
import Description from "../Description";
import MiniSurvey from "./MiniSurvey";
import IosArrowBack from "@meronex/icons/ios/IosArrowBack";

// Removed direct store imports; using injected redux props
import SideModal from "../../../Common/SideModal";
import Fireworks from "../../../Common/FireWorks";
import DealValidity from "./Components/DealValidity";
import TnC from "./Components/TnC";
import MoreOffers from "./Components/MoreOffers";
import { AlertSvg, BuyNowSvg, testSvg, TickSvg } from "./Components/SVG";
import ZeroState from "../../../Common/ZeroState";
import RewardsPopupModal from "../../../Common/RewardsPopupModal";
import { Coin } from "../DealsLayout/svg";
import MdcContentCopy from "@meronex/icons/mdc/MdcContentCopy";
import BsArrowRight from "@meronex/icons/bs/BsArrowRight";
import DealRedemptionModal from "./DealRedemptionModal";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var settings = {
  // dots: true,
  infinite: true,
  // speed: 10000,
  slidesToShow: 5,
  // slidesToScroll: 1,
  vertical: true,
  verticalSwiping: true,
  width: "70px",
  draggable: true,
  slidesToScroll: 3
  // adaptiveHeight: true,
  // easing: 'linear'
};
var isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
function DealDetails(_ref) {
  var _redux$auth, _ref2, _redux$isKycModalEnab, _redux$deal, _redux$deals, _config$deals, _ref3, _redux$showRewardsMod, _redux$deal2, _redux$deals2, _redux$auth2, _redux$auth3, _redux$webView, _redux$auth4, _redux$webView2, _deal$category2, _deal$category3, _deal$tags, _deal$tags2, _deal$tags3, _deal$tags4, _redux$auth5, _redux$auth6, _redux$auth7, _redux$auth8, _redux$auth9, _redux$deals3, _redux$deals5, _deal$category8, _config$sectionBackgr, _config$sectionBackgr2, _config$sectionBackgr3, _config$sectionBackgr4, _config$sectionBackgr5, _config$sectionBackgr6, _config$sectionBackgr7, _config$sectionBackgr8, _deal$displayImage4, _deal$additionalBanne, _deal$displayImage5, _deal$displayImage6, _deal$displayImage7, _deal$additionalBanne2, _deal$additionalBanne3, _deal$displayImage8, _deal$displayImage9, _deal$additionalBanne4, _deal$displayImage0, _deal$displayImage1, _deal$displayImage10, _deal$additionalBanne5, _deal$additionalBanne6, _deal$vendor4, _deal$brand, _deal$vendor5, _deal$vendor6, _config$projects$modu, _deal$vendor7, _redux$store, _redux$store2;
  var isRewards = _ref.isRewards,
    isPoints = _ref.isPoints,
    config = _ref.config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    cmsClient = _ref.cmsClient,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    appType = _ref.appType,
    _ref$showAppDownload = _ref.showAppDownload,
    showAppDownload = _ref$showAppDownload === void 0 ? false : _ref$showAppDownload;
  console.log({
    redux: redux,
    config: config
  });
  var params = (router === null || router === void 0 ? void 0 : router.params) || {};
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {},
    goBack: function goBack() {},
    length: 0
  };
  var location = (router === null || router === void 0 ? void 0 : router.location) || {
    search: "",
    pathname: ""
  };
  var currentUrl = window.location.pathname;

  // Get query parameters early to use in useData hook
  var queryParams = new URLSearchParams(location.search);
  var isPublicView = queryParams.get("publicView") === "true";
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTerms = _useState2[0],
    setShowTerms = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showUnregisteredModal = _useState4[0],
    setShowUnregisteredModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    copiedText = _useState6[0],
    setCopiedText = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    copiedLink = _useState8[0],
    setCopiedLink = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    playVideo = _useState0[0],
    setPlayVideo = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showModal = _useState10[0],
    setShowModal = _useState10[1];
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    showShare = _useState12[0],
    setShowShare = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    voucherCode = _useState14[0],
    setVoucherCode = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    modalMessage = _useState16[0],
    setModalMessage = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    rememptionLoading = _useState18[0],
    setRedemptionLoading = _useState18[1];
  var _useState19 = useState(true),
    _useState20 = _slicedToArray(_useState19, 2),
    termsCheckbox = _useState20[0],
    setTermsCheckbox = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    previewItem = _useState22[0],
    setPreviewItem = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    disableCart = _useState24[0],
    setDisableCart = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showTnCWarning = _useState26[0],
    setShowTnCWarning = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    showMultipleRedemption = _useState28[0],
    setShowMultipleRedemption = _useState28[1];
  var _useData = useData(params.dealId, isRewards, appType, isPublicView, {
      redux: redux,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }, isPoints),
    loadingDeal = _useData.loadingDeal,
    deal = _useData.deal,
    similarOffers = _useData.similarOffers,
    topOffers = _useData.topOffers,
    sameBrandOffers = _useData.sameBrandOffers,
    bundleDeals = _useData.bundleDeals,
    bundleDealDetails = _useData.bundleDealDetails,
    faultyDeal = _useData.faultyDeal,
    otherBundleDeals = _useData.otherBundleDeals;
  console.log("Deal INside detail", deal);
  console.log("otherbundleDeals", otherBundleDeals);
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var _useKYC = useKYC({
      router: {
        history: history,
        location: location
      },
      config: config,
      winnreAuth: winnreAuth,
      winnreNoAuth: winnreNoAuth,
      cmsClient: cmsClient,
      redux: {
        dispatch: dispatch,
        dealAction: redux === null || redux === void 0 ? void 0 : redux.dealAction
      }
    }),
    step = _useKYC.step,
    setStep = _useKYC.setStep,
    setError = _useKYC.setError,
    showError = _useKYC.showError,
    checkKycVerificationStatus = _useKYC.checkKycVerificationStatus,
    closeKYCModal = _useKYC.closeKYCModal,
    setOpenKYCModal = _useKYC.setOpenKYCModal,
    openKYCModal = _useKYC.openKYCModal,
    loading = _useKYC.loading,
    checkBankVerificationStatus = _useKYC.checkBankVerificationStatus,
    isUpdateWorkflow = _useKYC.isUpdateWorkflow,
    isKycCompleted = _useKYC.isKycCompleted,
    initiateWorkflow = _useKYC.initiateWorkflow,
    claimInProgress = _useKYC.claimInProgress,
    rewardTypeSelected = _useKYC.rewardTypeSelected,
    cashOutFlow = _useKYC.cashOutFlow,
    setClaimInProgress = _useKYC.setClaimInProgress,
    bankstatus = _useKYC.bankstatus,
    isKycFailed = _useKYC.isKycFailed,
    isBankVerificationFailed = _useKYC.isBankVerificationFailed,
    isKycProcessing = _useKYC.isKycProcessing;
  var _useBookingSummary = useBookingSummary({
      redux: {
        isAuthenticated: redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.isAuthenticated,
        dispatch: dispatch,
        authActions: redux === null || redux === void 0 ? void 0 : redux.authActions
      },
      winnreAuth: winnreAuth,
      appType: appType,
      isPoints: isPoints
    }),
    userAccountSummary = _useBookingSummary.userAccountSummary,
    getUserAccountSummary = _useBookingSummary.getUserAccountSummary;
  var isCuratedRoute = location.pathname.includes("/curated/");
  var accessToken = queryParams.get("token");
  var userToken = queryParams.get("userToken");
  var clientToken = queryParams.get("clientToken");
  var dealCategory = queryParams.get("category");
  var tagId = queryParams.get("tagid");
  var channel = queryParams.get("utm_medium");
  var userHash = queryParams.get("user");
  var isRedeemUser = queryParams.get("user") ? true : false;
  var autoRedeem = queryParams.get("autoRedeem");
  // config injected via props
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    showShareModal = _useState30[0],
    setShowShareModal = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    copiedUrl = _useState32[0],
    setCopiedUrl = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    captureUserMobile = _useState34[0],
    setCaptureUserMobile = _useState34[1];
  var _useState35 = useState(null),
    _useState36 = _slicedToArray(_useState35, 2),
    redemptionId = _useState36[0],
    setRedemptionId = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    prefilledData = _useState38[0],
    setPrefilledData = _useState38[1];
  var _useState39 = useState(""),
    _useState40 = _slicedToArray(_useState39, 2),
    link = _useState40[0],
    setLink = _useState40[1];
  var _useState41 = useState(""),
    _useState42 = _slicedToArray(_useState41, 2),
    shareLink = _useState42[0],
    setShareLink = _useState42[1]; // used to generate short share link
  var _useState43 = useState(false),
    _useState44 = _slicedToArray(_useState43, 2),
    showSurvey = _useState44[0],
    setShowSurvey = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    itemAdded = _useState46[0],
    setItemAdded = _useState46[1];
  var isKycModalEnabled = (_ref2 = (_redux$isKycModalEnab = redux === null || redux === void 0 ? void 0 : redux.isKycModalEnabled) !== null && _redux$isKycModalEnab !== void 0 ? _redux$isKycModalEnab : redux === null || redux === void 0 || (_redux$deal = redux.deal) === null || _redux$deal === void 0 ? void 0 : _redux$deal.isKycModalEnabled) !== null && _ref2 !== void 0 ? _ref2 : redux === null || redux === void 0 || (_redux$deals = redux.deals) === null || _redux$deals === void 0 ? void 0 : _redux$deals.isKycModalEnabled;
  var redeemNowButtonConfig = config === null || config === void 0 || (_config$deals = config.deals) === null || _config$deals === void 0 || (_config$deals = _config$deals.dealLayout) === null || _config$deals === void 0 ? void 0 : _config$deals.redeemNowButtonConfig;
  var showRewardsModal = (_ref3 = (_redux$showRewardsMod = redux === null || redux === void 0 ? void 0 : redux.showRewardsModal) !== null && _redux$showRewardsMod !== void 0 ? _redux$showRewardsMod : redux === null || redux === void 0 || (_redux$deal2 = redux.deal) === null || _redux$deal2 === void 0 ? void 0 : _redux$deal2.showRewardsModal) !== null && _ref3 !== void 0 ? _ref3 : redux === null || redux === void 0 || (_redux$deals2 = redux.deals) === null || _redux$deals2 === void 0 ? void 0 : _redux$deals2.showRewardsModal;

  // const token = redux?.auth?.token;
  var isAuthenticated = redux === null || redux === void 0 || (_redux$auth2 = redux.auth) === null || _redux$auth2 === void 0 ? void 0 : _redux$auth2.isAuthenticated;
  var userMobile = redux === null || redux === void 0 || (_redux$auth3 = redux.auth) === null || _redux$auth3 === void 0 || (_redux$auth3 = _redux$auth3.userDetails) === null || _redux$auth3 === void 0 ? void 0 : _redux$auth3.mobileNumber;
  var openLoginModal = function openLoginModal() {
    var _redux$authActions;
    if (dispatch && redux !== null && redux !== void 0 && (_redux$authActions = redux.authActions) !== null && _redux$authActions !== void 0 && _redux$authActions.openLoginModal) {
      dispatch(redux.authActions.openLoginModal());
    }
  };
  var openLoginModalForDealRedeem = function openLoginModalForDealRedeem() {
    var _redux$authActions2;
    if (dispatch && redux !== null && redux !== void 0 && (_redux$authActions2 = redux.authActions) !== null && _redux$authActions2 !== void 0 && _redux$authActions2.openLoginModalForDealRedeem) {
      dispatch(redux.authActions.openLoginModalForDealRedeem());
    }
  };
  console.log("showTncWarning", showTnCWarning);
  useEffect(function () {
    var visitCount = sessionStorage.getItem("dealDetailsVisitCount");
    var visitNum = visitCount ? parseInt(visitCount, 10) : 0;
    visitNum += 1;
    sessionStorage.setItem("dealDetailsVisitCount", visitNum);
    var surveyShown = sessionStorage.getItem("surveyShown");
    if (!surveyShown && visitNum >= 4) {
      setShowSurvey(true);
      console.log("visitCount", visitNum);
    }
  }, []);
  var handleCloseSurvey = function handleCloseSurvey() {
    setShowSurvey(false);
    sessionStorage.setItem("surveyShown", "true");
  };

  // checkout handler

  var checkKYCStatus = function checkKYCStatus() {
    if (isPoints) {
      var _redux$dealAction;
      if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction = redux.dealAction) !== null && _redux$dealAction !== void 0 && _redux$dealAction.setShowRewardsModal) {
        dispatch(redux.dealAction.setShowRewardsModal(true));
      } //
    } else {
      winnreAuth === null || winnreAuth === void 0 || winnreAuth({
        method: "GET",
        url: "/winnre/user/user/kyc-status"
      }).then(function (message) {
        if (message.message == "COMPLETED") {
          var _redux$dealAction2;
          if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction2 = redux.dealAction) !== null && _redux$dealAction2 !== void 0 && _redux$dealAction2.setShowRewardsModal) {
            dispatch(redux.dealAction.setShowRewardsModal(true));
          } // Open modal on Buy Now click
          // history.push(`/checkout`);
        }
        if (message.message == "NOT_INITIATED" || message.message == "INITIATED" || message.message === "null" || message.message === "FAILED" || message.message == "PROCESSING") {
          checkKycVerificationStatus(false, true, false);
          setOpenKYCModal(true);
        }
      });
    }
  };
  // To open kyc modal from cart checkout
  useEffect(function () {
    if (isKycModalEnabled) {
      setOpenKYCModal(true);
    }
  }, [isKycModalEnabled]);
  var handleCheckOut = function handleCheckOut(isBuyNow) {
    if (isBuyNow) {
      if (!isPublicView) {
        var _window, _deal$category;
        (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("BuyNowClicked", {
          category: "".concat(deal === null || deal === void 0 || (_deal$category = deal.category) === null || _deal$category === void 0 ? void 0 : _deal$category.name),
          ProductName: "".concat(deal === null || deal === void 0 ? void 0 : deal.title),
          Price: "".concat(deal === null || deal === void 0 ? void 0 : deal.productMrp),
          PointsRequired: "".concat(deal === null || deal === void 0 ? void 0 : deal.points)
        });
      }
      OnCartClick(false);
    }
    if (!isPublicView) {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("RewardRedemptionAttempt");
    }
    checkKYCStatus();

    // checkKycVerificationStatus(false, true);
    // setOpenKYCModal(true);
    // setError(null);
    //UNCOMMENT
    // history.push(`/checkout/${deal?.id}`);
  };

  // Hide the background scroll when modal is enabled.
  useEffect(function () {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = ""; // Reset to default when modal is closed
    }

    // Cleanup function to ensure overflow is reset when the component unmounts
    return function () {
      document.body.style.overflow = "";
    };
  }, [showModal]);
  var clientWebview = redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.clientWebview;
  var userStatus = redux === null || redux === void 0 || (_redux$auth4 = redux.auth) === null || _redux$auth4 === void 0 || (_redux$auth4 = _redux$auth4.userDetails) === null || _redux$auth4 === void 0 ? void 0 : _redux$auth4.status;
  var internalWebview = redux === null || redux === void 0 || (_redux$webView2 = redux.webView) === null || _redux$webView2 === void 0 ? void 0 : _redux$webView2.internalWebview;
  var clickThroughMobile = clientWebview || internalWebview;
  var isBundleDeal = (deal === null || deal === void 0 || (_deal$category2 = deal.category) === null || _deal$category2 === void 0 ? void 0 : _deal$category2.id) == "8";
  var isFinanceDeal = (deal === null || deal === void 0 || (_deal$category3 = deal.category) === null || _deal$category3 === void 0 ? void 0 : _deal$category3.id) == "3";
  console.log("UserStatus", userStatus);
  var isOfflineTag = deal === null || deal === void 0 || (_deal$tags = deal.tags) === null || _deal$tags === void 0 ? void 0 : _deal$tags.some(function (tag) {
    return tag.name === "Offline";
  });
  var hasBothTags = (deal === null || deal === void 0 || (_deal$tags2 = deal.tags) === null || _deal$tags2 === void 0 ? void 0 : _deal$tags2.some(function (tag) {
    return tag.name === "Offline";
  })) && (deal === null || deal === void 0 || (_deal$tags3 = deal.tags) === null || _deal$tags3 === void 0 ? void 0 : _deal$tags3.some(function (tag) {
    return tag.name === "Multiple";
  }));
  var isHouseWarmingTag = deal === null || deal === void 0 || (_deal$tags4 = deal.tags) === null || _deal$tags4 === void 0 ? void 0 : _deal$tags4.some(function (tag) {
    return tag.name === "House Warming";
  });

  // console.log("hasBothTags" , hasBothTags);
  useEffect(function () {
    setTermsCheckbox(true);
  }, [params === null || params === void 0 ? void 0 : params.dealId]);
  useEffect(function () {
    var enableShare = userHash ? false : true;
    if (!isPublicView && !isAuthenticated && !userToken && !accessToken && !clientToken && enableShare && !(deal !== null && deal !== void 0 && deal.shareable)) {
      openLoginModal();
    }
    setShowShare(enableShare);
  }, []);
  useEffect(function () {
    if (deal && !isPublicView) {
      var _window3, _deal$vendor, _deal$category4, _deal$displayImage, _deal$dealRedemptionC, _deal$category5, _deal$tags5;
      (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.webengage) === null || _window3 === void 0 || _window3.track("DealViewed", {
        OfferName: "".concat(deal === null || deal === void 0 ? void 0 : deal.title),
        Brand: "".concat(deal === null || deal === void 0 || (_deal$vendor = deal.vendor) === null || _deal$vendor === void 0 ? void 0 : _deal$vendor.name),
        OfferType: "".concat(deal === null || deal === void 0 || (_deal$category4 = deal.category) === null || _deal$category4 === void 0 ? void 0 : _deal$category4.name),
        OfferImage: "".concat(deal === null || deal === void 0 || (_deal$displayImage = deal.displayImage) === null || _deal$displayImage === void 0 ? void 0 : _deal$displayImage.url),
        CashbackPercentage: "".concat(deal === null || deal === void 0 ? void 0 : deal.eligibleCashback),
        CouponCode: "".concat(deal === null || deal === void 0 || (_deal$dealRedemptionC = deal.dealRedemptionCode) === null || _deal$dealRedemptionC === void 0 ? void 0 : _deal$dealRedemptionC.dealCode),
        Category: "".concat(deal === null || deal === void 0 || (_deal$category5 = deal.category) === null || _deal$category5 === void 0 ? void 0 : _deal$category5.name),
        Link: "".concat(deal === null || deal === void 0 ? void 0 : deal.url),
        EndDate: "".concat(deal === null || deal === void 0 ? void 0 : deal.endDate),
        Tags: "".concat(deal === null || deal === void 0 || (_deal$tags5 = deal.tags) === null || _deal$tags5 === void 0 ? void 0 : _deal$tags5.map(function (tag) {
          return tag === null || tag === void 0 ? void 0 : tag.name;
        })),
        DealId: "".concat(deal === null || deal === void 0 ? void 0 : deal.id),
        SectionName: "".concat(isRewards === true ? "Rewards" : "Deals"),
        DealPoint: "".concat(deal === null || deal === void 0 ? void 0 : deal.points),
        Mrp: "".concat(deal === null || deal === void 0 ? void 0 : deal.productMrp),
        RedemptionType: "".concat(deal === null || deal === void 0 ? void 0 : deal.redemptionType),
        Points: deal === null || deal === void 0 ? void 0 : deal.points
      });
    }
    if (deal !== null && deal !== void 0 && deal.videoUrl) {
      setPreviewItem(deal === null || deal === void 0 ? void 0 : deal.videoUrl);
    } else {
      var _deal$displayImage2;
      setPreviewItem(deal === null || deal === void 0 || (_deal$displayImage2 = deal.displayImage) === null || _deal$displayImage2 === void 0 ? void 0 : _deal$displayImage2.url);
    }
  }, [deal]);
  useEffect(function () {
    if (deal && autoRedeem) {
      if (isBundleDeal) {
        if ((bundleDeals === null || bundleDeals === void 0 ? void 0 : bundleDeals.length) > 0 && (bundleDealDetails === null || bundleDealDetails === void 0 ? void 0 : bundleDealDetails.length) > 0) {
          queryParams["delete"]("autoRedeem");
          history.replace({
            search: queryParams.toString()
          });
          redeemNowClickedHandler(deal.url, deal.id, deal === null || deal === void 0 ? void 0 : deal.redemptionType);
        }
      } else {
        queryParams["delete"]("autoRedeem");
        history.replace({
          search: queryParams.toString()
        });
        redeemNowClickedHandler(deal.url, deal.id, deal === null || deal === void 0 ? void 0 : deal.redemptionType);
      }
    }
  }, [deal, bundleDealDetails, bundleDeals]);
  var handleCopyCode = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _deal$dealRedemptionC2;
      var code;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            code = (deal === null || deal === void 0 ? void 0 : deal.redemptionType) == "VOUCHER" ? voucherCode : deal === null || deal === void 0 || (_deal$dealRedemptionC2 = deal.dealRedemptionCode) === null || _deal$dealRedemptionC2 === void 0 ? void 0 : _deal$dealRedemptionC2.dealCode;
            _context.n = 1;
            return copyCodeHandler(code, setCopiedText);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleCopyCode() {
      return _ref4.apply(this, arguments);
    };
  }();
  var copyCodeHandler = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data, setCopiedState) {
      var _window4, _window5;
      var cardId,
        valueToSend,
        _args2 = arguments;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            cardId = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
            console.log("data", data);
            valueToSend = {
              message: "COPY",
              value: data
            };
            (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.webkit) === null || _window4 === void 0 || (_window4 = _window4.messageHandlers) === null || _window4 === void 0 || _window4.jsMessageHandler.postMessage(valueToSend);
            (_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.JSBridge) === null || _window5 === void 0 || _window5.showMessageInNative(link);
            if (!("clipboard" in navigator)) {
              _context2.n = 1;
              break;
            }
            _context2.n = 1;
            return navigator.clipboard.writeText(data);
          case 1:
            setCopiedState(true);
            if (cardId) {
              setCopiedState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, cardId, true));
              });
              setTimeout(function () {
                setCopiedState(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, cardId, false));
                });
              }, 1500);
            } else {
              setCopiedState(true);
              setTimeout(function () {
                setCopiedState(false);
              }, 1500);
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function copyCodeHandler(_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleCopyLink = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return copyCodeHandler(deal === null || deal === void 0 ? void 0 : deal.url, setCopiedLink);
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function handleCopyLink() {
      return _ref6.apply(this, arguments);
    };
  }();
  var imgArr = bundleDeals === null || bundleDeals === void 0 ? void 0 : bundleDeals.map(function (deal) {
    return {
      imgUrl: (deal === null || deal === void 0 ? void 0 : deal.vendorLogoUrl) || "",
      dealName: deal === null || deal === void 0 ? void 0 : deal.title,
      dealImage: deal !== null && deal !== void 0 && deal.thumbnailImageUrl ? deal === null || deal === void 0 ? void 0 : deal.thumbnailImageUrl : deal === null || deal === void 0 ? void 0 : deal.displayImageUrl,
      dealId: deal === null || deal === void 0 ? void 0 : deal.id
    };
  });
  var getPrefilledData = function getPrefilledData() {
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "GET",
      url: "/winnre/user/property/consultation-deal-additional-details"
    }).then(function (res) {
      console.log("prefilledData", res);
      setPrefilledData(res);
    });
  };
  var redeemNowClickedHandler = function redeemNowClickedHandler(url, id, redemptionType, mobile) {
    if (isRedeemUser && !isAuthenticated) {
      // enable only if the user access the shared deal
      history.push("".concat(location.pathname, "?postLoginUrl=/deals/").concat(id, "?autoRedeem=true"));
      openLoginModalForDealRedeem();
    } else if (!isPublicView && !isAuthenticated && !userToken && !accessToken && !clientToken) {
      openLoginModal();
    } else {
      var _cmsClient$defaults, _cmsClient$defaults2;
      if (!userMobile && !mobile) {
        setCaptureUserMobile(true);
        setShowModal(true);
        return;
      }
      setRedemptionLoading(true);
      setModalMessage(null);
      if ((cmsClient === null || cmsClient === void 0 || (_cmsClient$defaults = cmsClient.defaults) === null || _cmsClient$defaults === void 0 ? void 0 : _cmsClient$defaults.baseURL) === "https://prod.loyalie.in" || (cmsClient === null || cmsClient === void 0 || (_cmsClient$defaults2 = cmsClient.defaults) === null || _cmsClient$defaults2 === void 0 ? void 0 : _cmsClient$defaults2.baseURL) === "https://uat.loyalie.in") {
        // window.fbq("trackCustom", "RedeemNowButtonClicked"); redo
      }
      ReactGA.event({
        category: "OFFER",
        action: "REDEEM NOW CLICKED",
        label: "REDEEM OFFER BUTTON"
      });
      var apiCall;

      // To add source user if the deal is shared.

      var sourceUserId = userHash ? "&sourceUserId=".concat(userHash) : "";
      if (isBundleDeal) {
        apiCall = Promise.all(bundleDeals === null || bundleDeals === void 0 ? void 0 : bundleDeals.map(function (bundleDeal) {
          return winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
            method: "POST",
            url: "winnre/user/deals/redeem-v2?dealId=".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.id, "&sourcePlatform=").concat(clickThroughMobile ? "MOBILE" : "WEBSITE").concat(channel ? "&channel=".concat(channel) : "").concat(sourceUserId)
          });
        }));
      } else {
        apiCall = winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
          method: "POST",
          url: "winnre/user/deals/redeem-v2?dealId=".concat(id, "&sourcePlatform=").concat(clickThroughMobile ? "MOBILE" : "WEBSITE").concat(channel ? "&channel=".concat(channel) : "").concat(sourceUserId)
        });
      }
      apiCall.then(function (res) {
        console.log("redeem", res);
        setRedemptionId(res === null || res === void 0 ? void 0 : res.dealRedemptionId);
        if (isBundleDeal) {
          var index = 0;
          var offers = bundleDealDetails || [];
          var _iterator = _createForOfIteratorHelper(bundleDeals),
            _step;
          try {
            var _loop = function _loop() {
              var _res$index0, _res$index1, _res$index10, _res$index11, _res$index12, _res$index13, _res$index14, _res$index15, _res$index16;
              var bundleDeal = _step.value;
              // console.log(bundleDeal.title, bundleDeal.redemptionType, bundleDeal.eligibleCashback, bundleDeal.dealRedemptionCode, bundleDeal.endDate, bundleDeal.id, bundleDeal.categoryName, bundleDeal.vendorName)
              if (!isPublicView) {
                var _window7, _bundleDeal$tags, _res$index, _res$index2, _res$index3, _res$index4, _res$index5, _res$index6, _res$index7, _res$index8, _res$index9;
                (_window7 = window) === null || _window7 === void 0 || (_window7 = _window7.webengage) === null || _window7 === void 0 || _window7.track("DealClicked", _objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
                  OfferName: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.title),
                  RedemptionType: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.redemptionType),
                  CashbackPercentage: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.eligibleCashback),
                  CouponCode: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.dealRedemptionCode),
                  Category: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.categoryName),
                  Vendor: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.vendorName),
                  Link: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.url),
                  EndDate: "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.endDate),
                  SectionName: "".concat(isRewards === true ? "Rewards" : "Deals"),
                  DealPoint: "".concat(deal === null || deal === void 0 ? void 0 : deal.points),
                  Mrp: "".concat(deal === null || deal === void 0 ? void 0 : deal.productMrp)
                }, "RedemptionType", "".concat(deal === null || deal === void 0 ? void 0 : deal.redemptionType)), "Tags", "".concat(bundleDeal === null || bundleDeal === void 0 || (_bundleDeal$tags = bundleDeal.tags) === null || _bundleDeal$tags === void 0 ? void 0 : _bundleDeal$tags.map(function (tag) {
                  return tag === null || tag === void 0 ? void 0 : tag.name;
                }))), "DealId", "".concat(bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.id)), "VoucherCode", bundleDeal.dealType === "OFFLINE" ? "" : (bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.redemptionType) === "VOUCHER" && ((_res$index = res[index]) === null || _res$index === void 0 ? void 0 : _res$index.status) == "SUCCESS" ? (_res$index2 = res[index]) === null || _res$index2 === void 0 ? void 0 : _res$index2.dealCode : ((_res$index3 = res[index]) === null || _res$index3 === void 0 ? void 0 : _res$index3.status) == "FAILED" && (_res$index4 = res[index]) !== null && _res$index4 !== void 0 && _res$index4.message.includes("Repeat:") ? (_res$index5 = res[index]) === null || _res$index5 === void 0 ? void 0 : _res$index5.message.split("Repeat:")[1] : ""), "Channel", channel ? channel : "Direct"), bundleDeal.redemptionType === "VOUCHER" && bundleDeal.dealType === "OFFLINE" && {
                  QRCode: ((_res$index6 = res[index]) === null || _res$index6 === void 0 ? void 0 : _res$index6.status) == "SUCCESS" ? (_res$index7 = res[index]) === null || _res$index7 === void 0 ? void 0 : _res$index7.dealQrCodeLink : ((_res$index8 = res[index]) === null || _res$index8 === void 0 ? void 0 : _res$index8.status) == "FAILED" ? (_res$index9 = res[index]) === null || _res$index9 === void 0 ? void 0 : _res$index9.message.split("Repeat:")[1] : ""
                }));
              }
              var offersIndex = offers.findIndex(function (o) {
                return o.id === (bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.id);
              });
              offers[offersIndex] = _objectSpread(_objectSpread(_objectSpread({}, offers[offersIndex]), bundleDeal), {}, {
                VoucherCode: bundleDeal.dealType === "OFFLINE" ? "" : (bundleDeal === null || bundleDeal === void 0 ? void 0 : bundleDeal.redemptionType) === "VOUCHER" && ((_res$index0 = res[index]) === null || _res$index0 === void 0 ? void 0 : _res$index0.status) == "SUCCESS" ? (_res$index1 = res[index]) === null || _res$index1 === void 0 ? void 0 : _res$index1.dealCode : ((_res$index10 = res[index]) === null || _res$index10 === void 0 ? void 0 : _res$index10.status) == "FAILED" && (_res$index11 = res[index]) !== null && _res$index11 !== void 0 && _res$index11.message.includes("Repeat:") ? (_res$index12 = res[index]) === null || _res$index12 === void 0 ? void 0 : _res$index12.message.split("Repeat:")[1] : ""
              }, bundleDeal.redemptionType === "VOUCHER" && bundleDeal.dealType === "OFFLINE" && {
                QRCode: ((_res$index13 = res[index]) === null || _res$index13 === void 0 ? void 0 : _res$index13.status) == "SUCCESS" ? (_res$index14 = res[index]) === null || _res$index14 === void 0 ? void 0 : _res$index14.dealQrCodeLink : ((_res$index15 = res[index]) === null || _res$index15 === void 0 ? void 0 : _res$index15.status) == "FAILED" ? (_res$index16 = res[index]) === null || _res$index16 === void 0 ? void 0 : _res$index16.message.split("Repeat:")[1] : ""
              });
              index++;
            };
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          setRedemptionLoading(false);
          history.push({
            pathname: "/bundleDetails",
            state: {
              offers: offers,
              filteredOffers: otherBundleDeals
            }
          });
          if (!isPublicView) {
            var _window6;
            (_window6 = window) === null || _window6 === void 0 || (_window6 = _window6.webengage) === null || _window6 === void 0 || _window6.track("PdfViewed");
          }
        } else {
          if (!isPublicView) {
            var _window8, _deal$dealRedemptionC3, _deal$category6, _deal$vendor2, _deal$tags6;
            (_window8 = window) === null || _window8 === void 0 || (_window8 = _window8.webengage) === null || _window8 === void 0 || _window8.track("DealClicked", _objectSpread(_objectSpread(_defineProperty(_defineProperty({
              OfferName: "".concat(deal === null || deal === void 0 ? void 0 : deal.title),
              RedemptionType: "".concat(deal === null || deal === void 0 ? void 0 : deal.redemptionType),
              CashbackPercentage: "".concat(deal === null || deal === void 0 ? void 0 : deal.eligibleCashback),
              CouponCode: "".concat(deal === null || deal === void 0 || (_deal$dealRedemptionC3 = deal.dealRedemptionCode) === null || _deal$dealRedemptionC3 === void 0 ? void 0 : _deal$dealRedemptionC3.dealCode),
              Category: "".concat(deal === null || deal === void 0 || (_deal$category6 = deal.category) === null || _deal$category6 === void 0 ? void 0 : _deal$category6.name),
              Vendor: "".concat(deal === null || deal === void 0 || (_deal$vendor2 = deal.vendor) === null || _deal$vendor2 === void 0 ? void 0 : _deal$vendor2.name),
              Link: "".concat(deal === null || deal === void 0 ? void 0 : deal.url),
              EndDate: "".concat(deal === null || deal === void 0 ? void 0 : deal.endDate),
              Tags: "".concat(deal === null || deal === void 0 || (_deal$tags6 = deal.tags) === null || _deal$tags6 === void 0 ? void 0 : _deal$tags6.map(function (tag) {
                return tag === null || tag === void 0 ? void 0 : tag.name;
              })),
              DealId: "".concat(deal === null || deal === void 0 ? void 0 : deal.id),
              SectionName: "".concat(isRewards === true ? "Rewards" : "Deals"),
              DealPoint: "".concat(deal === null || deal === void 0 ? void 0 : deal.points),
              Mrp: "".concat(deal === null || deal === void 0 ? void 0 : deal.productMrp)
            }, "RedemptionType", "".concat(deal === null || deal === void 0 ? void 0 : deal.redemptionType)), "VoucherCode", (deal === null || deal === void 0 ? void 0 : deal.dealType) === "OFFLINE" ? "" : (deal === null || deal === void 0 ? void 0 : deal.redemptionType) === "VOUCHER" ? (res === null || res === void 0 ? void 0 : res.status) == "SUCCESS" ? res === null || res === void 0 ? void 0 : res.dealCode : (res === null || res === void 0 ? void 0 : res.status) == "FAILED" && res !== null && res !== void 0 && res.message.includes("Repeat:") ? res === null || res === void 0 ? void 0 : res.message.split("Repeat:")[1] : "" : ""), redemptionType === "VOUCHER" && deal.dealType === "OFFLINE" && {
              QRCode: (res === null || res === void 0 ? void 0 : res.status) == "SUCCESS" ? res === null || res === void 0 ? void 0 : res.dealQrCodeLink : (res === null || res === void 0 ? void 0 : res.status) == "FAILED" ? res !== null && res !== void 0 && res.message.includes("Repeat:") ? res === null || res === void 0 ? void 0 : res.message.split("Repeat:")[1] : "" : ""
            }), {}, {
              Status: res === null || res === void 0 ? void 0 : res.status,
              Channel: channel ? channel : "Direct"
            }));
          }
          setRedemptionLoading(false);
          if (userStatus !== "REGISTERED" && (res === null || res === void 0 ? void 0 : res.status) === "FAILED" && (res === null || res === void 0 ? void 0 : res.message) === "Deal redemption is not allowed for this user") {
            setShowUnregisteredModal(true);
            return;
          }
          if (hasBothTags) {
            setShowMultipleRedemption(true);
            return;
          }
          if ((res === null || res === void 0 ? void 0 : res.status) === "SUCCESS" && isFinanceDeal && res !== null && res !== void 0 && res.dealRedemptionId) {
            console.log("navigate to home loan");
            // Navigate to '/home-loan' and pass dealRedemptionId as state
            history.push("/home-loans", {
              dealRedemptionId: res.dealRedemptionId
            });
          }
          if (redemptionType === "CODE") {
            setShowModal(true);
            if ((res === null || res === void 0 ? void 0 : res.status) == "SUCCESS") {
              var _deal$dealRedemptionC4;
              setVoucherCode(deal === null || deal === void 0 || (_deal$dealRedemptionC4 = deal.dealRedemptionCode) === null || _deal$dealRedemptionC4 === void 0 ? void 0 : _deal$dealRedemptionC4.dealCode);
            }
            if ((res === null || res === void 0 ? void 0 : res.status) == "FAILED") {
              if (res !== null && res !== void 0 && res.message.includes("Repeat:")) {
                var _deal$dealRedemptionC5;
                setVoucherCode(deal === null || deal === void 0 || (_deal$dealRedemptionC5 = deal.dealRedemptionCode) === null || _deal$dealRedemptionC5 === void 0 ? void 0 : _deal$dealRedemptionC5.dealCode);
                setModalMessage(null);
              } else {
                setModalMessage(res === null || res === void 0 ? void 0 : res.message);
                setVoucherCode(null);
              }
            }
            return;
          }
          if (redemptionType === "LINK") {
            window.open(url);
            return;
          }
          if (redemptionType === "CONSULTATION") {
            if ((res === null || res === void 0 ? void 0 : res.status) == "SUCCESS" && isHouseWarmingTag && res !== null && res !== void 0 && res.dealRedemptionId) {
              setShowModal(true);
              getPrefilledData();
            }
            if (res.status === "FAILED") {
              setShowModal(true);
              setModalMessage(res.message);
            }
            return;
          }
          if (redemptionType === "VOUCHER") {
            setShowModal(true);
            if ((res === null || res === void 0 ? void 0 : res.status) == "SUCCESS") {
              if ((deal === null || deal === void 0 ? void 0 : deal.dealType) === "ONLINE") {
                setVoucherCode(res === null || res === void 0 ? void 0 : res.dealCode);
                setModalMessage(null);
              } else if ((deal === null || deal === void 0 ? void 0 : deal.dealType) === "OFFLINE") {
                setVoucherCode(res === null || res === void 0 ? void 0 : res.dealQRCodeLink);
                setModalMessage("Show the voucher code at the restaurant/store to claim your offer.");
              }
            }
            if ((res === null || res === void 0 ? void 0 : res.status) == "FAILED") {
              var code = res === null || res === void 0 ? void 0 : res.message.split("Repeat:");
              if (code.length > 1) {
                if ((deal === null || deal === void 0 ? void 0 : deal.dealType) === "ONLINE") {
                  var _deal$vendor3;
                  setVoucherCode(code[1]);
                  setModalMessage("You have already viewed your voucher! Go to ".concat(deal === null || deal === void 0 || (_deal$vendor3 = deal.vendor) === null || _deal$vendor3 === void 0 ? void 0 : _deal$vendor3.name, " website to redeem the voucher directly online"));
                } else if ((deal === null || deal === void 0 ? void 0 : deal.dealType) === "OFFLINE") {
                  setVoucherCode(code[1]);
                  setModalMessage("You have already redeemed this deal. We have resent the details to you!");
                }
              } else {
                setModalMessage(res === null || res === void 0 ? void 0 : res.message);
                setVoucherCode(null);
              }
            }
          }
        }
      })["catch"](function () {
        setRedemptionLoading(false);
        if (redemptionType === "CONSULTATION") {
          toast.error("Something Went Wrong");
        }
      });
    }
  };
  var handleTnC = function handleTnC() {
    setShowTerms(true);
    if (!isPublicView) {
      var _window9;
      (_window9 = window) === null || _window9 === void 0 || (_window9 = _window9.webengage) === null || _window9 === void 0 || _window9.track("TnCViewed", {
        dealId: "".concat(deal.id),
        dealTitle: "".concat(deal.title),
        vendorName: "".concat(deal.vendor.name),
        SectionName: "".concat(isRewards === true ? "Rewards" : "Deals"),
        DealPoint: "".concat(deal === null || deal === void 0 ? void 0 : deal.points),
        Mrp: "".concat(deal === null || deal === void 0 ? void 0 : deal.productMrp),
        RedemptionType: "".concat(deal === null || deal === void 0 ? void 0 : deal.redemptionType)
      });
    }
  };
  var handleOnChange = function handleOnChange() {
    setTermsCheckbox(function (prev) {
      return !prev;
    });
  };

  //To get logged in user details for share link.
  var userId = redux === null || redux === void 0 || (_redux$auth5 = redux.auth) === null || _redux$auth5 === void 0 ? void 0 : _redux$auth5.userHash;
  var user = redux === null || redux === void 0 || (_redux$auth6 = redux.auth) === null || _redux$auth6 === void 0 ? void 0 : _redux$auth6.userId;
  var userRole = redux === null || redux === void 0 || (_redux$auth7 = redux.auth) === null || _redux$auth7 === void 0 ? void 0 : _redux$auth7.userRole;
  var totalRewardspoint = isPoints ? redux === null || redux === void 0 || (_redux$auth8 = redux.auth) === null || _redux$auth8 === void 0 ? void 0 : _redux$auth8.reloyRewardPoints : redux === null || redux === void 0 || (_redux$auth9 = redux.auth) === null || _redux$auth9 === void 0 || (_redux$auth9 = _redux$auth9.redux) === null || _redux$auth9 === void 0 || (_redux$auth9 = _redux$auth9.auth) === null || _redux$auth9 === void 0 ? void 0 : _redux$auth9.rewardPoints;
  var isCartModalOpen = redux === null || redux === void 0 || (_redux$deals3 = redux.deals) === null || _redux$deals3 === void 0 ? void 0 : _redux$deals3.isCartModalVisible;
  //To generate shared deal link.
  var copyDealHandler = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            if (!("clipboard" in navigator)) {
              _context4.n = 3;
              break;
            }
            if (!(!isAuthenticated || userRole !== "CUSTOMER")) {
              _context4.n = 2;
              break;
            }
            _context4.n = 1;
            return navigator.clipboard.writeText(window.location.href);
          case 1:
            _context4.n = 3;
            break;
          case 2:
            if (!(userRole === "CUSTOMER")) {
              _context4.n = 3;
              break;
            }
            _context4.n = 3;
            return navigator.clipboard.writeText(link);
          case 3:
            setCopiedUrl(true);
          case 4:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function copyDealHandler() {
      return _ref7.apply(this, arguments);
    };
  }();

  //To copied deal url enable & disable.
  useEffect(function () {
    var timer = setTimeout(function () {
      setCopiedUrl(false);
    }, 1500);
    return function () {
      clearTimeout(timer);
    };
  }, [copiedUrl]);

  //On click share deal.
  var handleShareClick = function handleShareClick(e) {
    e.preventDefault();
    var links = encodeURIComponent("".concat(window.location.href.split("?")[0], "?dealId=").concat(deal === null || deal === void 0 ? void 0 : deal.id, "&userId=").concat(userId, "&user=").concat(user));
    //To get shortLink
    winnreAuth === null || winnreAuth === void 0 || winnreAuth.post("/winnre/user/short-link?URL=" + links).then(function (res) {
      setShareLink(res.shortURL);
      setLink(res.shortURL);
      if (internalWebview) {
        var _window0, _window1;
        // Message passing for Mobile view
        var valueToSend = {
          message: "SHARE_LINK",
          data: {
            message: deal.shareMessage ? deal.shareMessage : "Hello! Hope you're doing well. I wanted to share this exciting deal I found recently. Click to learn more!",
            value: res.shortURL
          }
        };
        // IOS message handler
        (_window0 = window) === null || _window0 === void 0 || (_window0 = _window0.webkit) === null || _window0 === void 0 || (_window0 = _window0.messageHandlers) === null || _window0 === void 0 || _window0.jsMessageHandler.postMessage(valueToSend);
        var stringifiedValueToSend = JSON.stringify(valueToSend);
        // Android message handler
        (_window1 = window) === null || _window1 === void 0 || (_window1 = _window1.JSBridge) === null || _window1 === void 0 || _window1.showMessageInNative(stringifiedValueToSend);
      }
      // Show Modal for web view
      else {
        setShowShareModal(true);
      }
    });
  };
  var productSpecifications = isRewards ? deal === null || deal === void 0 ? void 0 : deal.productSpecs : deal === null || deal === void 0 ? void 0 : deal.description;
  var formattedDealPoints = Number((deal === null || deal === void 0 ? void 0 : deal.points) || 0).toLocaleString("en-IN");

  // On cart click

  var handleClick = function handleClick() {
    if (!itemAdded) {
      setItemAdded(true);
      // <Fireworks/>
      setTimeout(function () {
        setItemAdded(false);
      }, 4000); // Reset after 4 seconds
    }
  };
  var OnCartClick = function OnCartClick(isAddToGiftBasket) {
    var _deal$displayImage3, _deal$thumbnailImage, _redux$dealAction3, _redux$deals$isRefres, _redux$deals4, _redux$dealAction4;
    if (!isPublicView) {
      var _window10, _deal$category7;
      (_window10 = window) === null || _window10 === void 0 || (_window10 = _window10.webengage) === null || _window10 === void 0 || _window10.track("AddToCartClicked", {
        category: "".concat(deal === null || deal === void 0 || (_deal$category7 = deal.category) === null || _deal$category7 === void 0 ? void 0 : _deal$category7.name),
        ProductName: "".concat(deal === null || deal === void 0 ? void 0 : deal.title),
        Price: "".concat(deal === null || deal === void 0 ? void 0 : deal.productMrp),
        PointsRequired: "".concat(deal === null || deal === void 0 ? void 0 : deal.points)
      });
    }
    var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
    var currentMrp = 0;
    var totalCartCount = 0;
    var totalPoints = 0;
    var cartData = {
      cartValues: [],
      totalMrp: currentMrp,
      totalPoints: totalPoints,
      totalProduct: totalCartCount
    };
    if (oldCartData) {
      var _cartData, _cartData2;
      cartData = JSON.parse(oldCartData);
      console.log("currentPoints", deal === null || deal === void 0 ? void 0 : deal.points, "cartTotalPoints", (_cartData = cartData) === null || _cartData === void 0 ? void 0 : _cartData.totalPoints, "rewardsTotal", totalRewardspoint);
      if (totalRewardspoint >= 0 && (deal === null || deal === void 0 ? void 0 : deal.points) + ((_cartData2 = cartData) === null || _cartData2 === void 0 ? void 0 : _cartData2.totalPoints) > totalRewardspoint) {
        setDisableCart(true);
        toast("You don't have enough reward points to redeem this item.");
        return;
      }
    }

    // Add the new product to cartValues
    cartData.cartValues.push({
      id: deal === null || deal === void 0 ? void 0 : deal.id,
      title: deal === null || deal === void 0 ? void 0 : deal.title,
      endDate: deal === null || deal === void 0 ? void 0 : deal.endDate,
      displayImageUrl: deal === null || deal === void 0 || (_deal$displayImage3 = deal.displayImage) === null || _deal$displayImage3 === void 0 ? void 0 : _deal$displayImage3.url,
      vendorLogoUrl: deal === null || deal === void 0 ? void 0 : deal.vendorLogoUrl,
      productMrp: deal === null || deal === void 0 ? void 0 : deal.productMrp,
      thumbnailImageUrl: deal === null || deal === void 0 || (_deal$thumbnailImage = deal.thumbnailImage) === null || _deal$thumbnailImage === void 0 ? void 0 : _deal$thumbnailImage.url,
      points: deal === null || deal === void 0 ? void 0 : deal.points,
      productShippingFee: deal === null || deal === void 0 ? void 0 : deal.productShippingFee,
      productConvenienceFee: deal === null || deal === void 0 ? void 0 : deal.productConvenienceFee,
      tags: deal === null || deal === void 0 ? void 0 : deal.tags
    });

    // Update totalMrp and totalProduct
    cartData.totalMrp += deal === null || deal === void 0 ? void 0 : deal.productMrp;
    cartData.totalPoints += deal === null || deal === void 0 ? void 0 : deal.points;
    cartData.totalShippingFee += deal === null || deal === void 0 ? void 0 : deal.productShippingFee;
    cartData.totalConvenienceFee += deal === null || deal === void 0 ? void 0 : deal.productConvenienceFee;
    cartData.totalProduct += 1;

    // Save updated cart data to localStorage
    if (isPoints) {
      localStorage.setItem("cartData_reloyrewardpoints", JSON.stringify(cartData));
    } else {
      localStorage.setItem("cartData", JSON.stringify(cartData));
    }
    // Dispatch a custom event to notify other components
    if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction3 = redux.dealAction) !== null && _redux$dealAction3 !== void 0 && _redux$dealAction3.setCartModalVisible) {
      dispatch(redux.dealAction.setCartModalVisible(true));
    }
    window.dispatchEvent(new Event("cartUpdated"));
    var isRefresh = !((_redux$deals$isRefres = redux === null || redux === void 0 || (_redux$deals4 = redux.deals) === null || _redux$deals4 === void 0 ? void 0 : _redux$deals4.isRefreshRewards) !== null && _redux$deals$isRefres !== void 0 ? _redux$deals$isRefres : redux === null || redux === void 0 ? void 0 : redux.isRewardRefreshing);
    if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction4 = redux.dealAction) !== null && _redux$dealAction4 !== void 0 && _redux$dealAction4.setIsRewardRefreshing) {
      dispatch(redux.dealAction.setIsRewardRefreshing(isRefresh));
    }
    if (isAddToGiftBasket) {
      handleClick();
    }
    // handleClick();
  };
  useEffect(function () {
    window.addEventListener("cartUpdated", function () {
      var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
      console.log("cart working", authActions.rewardPoints);
      if (oldCartData) {
        var cartData = JSON.parse(oldCartData);
        if ((deal === null || deal === void 0 ? void 0 : deal.points) + (cartData === null || cartData === void 0 ? void 0 : cartData.totalPoints) > totalRewardspoint) {
          setDisableCart(true);
        } else {
          setDisableCart(false);
        }
      }
    });
  }, []);
  var isCartModalVisible = redux === null || redux === void 0 || (_redux$deals5 = redux.deals) === null || _redux$deals5 === void 0 ? void 0 : _redux$deals5.isCartModalVisible;
  console.log("cartModalVisible", isCartModalVisible);
  var handleBackClick = function handleBackClick() {
    var _location$state;
    // The page we came from, recorded when the card was clicked. It already
    // contains the filters and ?page=N, so this returns the user exactly where
    // they were. We don't use history.goBack() because the entry behind this
    // page is not reliably the listing.
    var from = location === null || location === void 0 || (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.from;
    if (from) {
      history.push(from);
      return;
    }

    // Opened directly (shared link or refresh) so we have no origin. Send the
    // user to the store this deal belongs to — never the homepage.
    if (currentUrl.includes("rewardPointStore")) {
      history.push("/rewardPointStore");
    } else if (currentUrl.includes("rewardStore")) {
      history.push("/rewardStore");
    } else if (currentUrl.includes("curated")) {
      history.push("/curatedDeals");
    } else {
      history.push("/deals");
    }
  };
  var isVoucherDeal = (deal === null || deal === void 0 ? void 0 : deal.redemptionType) === "VOUCHER";
  var isCodeDeal = (deal === null || deal === void 0 ? void 0 : deal.redemptionType) === "CODE";
  var isOnlineDeal = (deal === null || deal === void 0 ? void 0 : deal.dealType) == "ONLINE";
  var isOfflineDeal = (deal === null || deal === void 0 ? void 0 : deal.dealType) == "OFFLINE";
  var isExternalDeal = (deal === null || deal === void 0 || (_deal$category8 = deal.category) === null || _deal$category8 === void 0 ? void 0 : _deal$category8.name) == "External";
  return /*#__PURE__*/_jsxs("div", {
    className: " ".concat(showAppDownload ? "pb-16" : "", " ").concat(internalWebview ? "mb-16" : "", " ").concat(config !== null && config !== void 0 && config.darkMode ? "bg-black" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white")),
    onClick: function onClick() {
      var _redux$dealAction5;
      console.log("Click working");
      if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction5 = redux.dealAction) !== null && _redux$dealAction5 !== void 0 && _redux$dealAction5.setCartModalVisible) {
        dispatch(redux.dealAction.setCartModalVisible(false));
      }
    },
    style: {
      backgroundImage: "linear-gradient(90deg, rgba(".concat(config === null || config === void 0 || (_config$sectionBackgr = config.sectionBackground) === null || _config$sectionBackgr === void 0 ? void 0 : _config$sectionBackgr.color, ", ").concat(config === null || config === void 0 || (_config$sectionBackgr2 = config.sectionBackground) === null || _config$sectionBackgr2 === void 0 ? void 0 : _config$sectionBackgr2.opacity, "), rgba(").concat(config === null || config === void 0 || (_config$sectionBackgr3 = config.sectionBackground) === null || _config$sectionBackgr3 === void 0 ? void 0 : _config$sectionBackgr3.color, ", ").concat(config === null || config === void 0 || (_config$sectionBackgr4 = config.sectionBackground) === null || _config$sectionBackgr4 === void 0 ? void 0 : _config$sectionBackgr4.opacity, ")), url('").concat(config !== null && config !== void 0 && (_config$sectionBackgr5 = config.sectionBackground) !== null && _config$sectionBackgr5 !== void 0 && _config$sectionBackgr5.image ? config === null || config === void 0 || (_config$sectionBackgr6 = config.sectionBackground) === null || _config$sectionBackgr6 === void 0 ? void 0 : _config$sectionBackgr6.image : "", "')"),
      backgroundSize: "".concat(config !== null && config !== void 0 && (_config$sectionBackgr7 = config.sectionBackground) !== null && _config$sectionBackgr7 !== void 0 && _config$sectionBackgr7.size ? config === null || config === void 0 || (_config$sectionBackgr8 = config.sectionBackground) === null || _config$sectionBackgr8 === void 0 ? void 0 : _config$sectionBackgr8.size : "30% auto")
    },
    children: [/*#__PURE__*/_jsxs("section", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "\n                    ".concat(config === null || config === void 0 ? void 0 : config.bannerNegativeTopMarginClass, " w-full h-auto  "),
        children: [(config === null || config === void 0 ? void 0 : config.header) && /*#__PURE__*/_jsx("div", {
          className: config === null || config === void 0 ? void 0 : config.header.headerClass
        }), loadingDeal && /*#__PURE__*/_jsx("div", {
          className: "h-auto mx-auto ",
          children: /*#__PURE__*/_jsx("div", {
            className: "lg:mx-4 ",
            children: _toConsumableArray(Array(1).keys()).map(function (n) {
              return /*#__PURE__*/_jsx(SkeletonDeal, {
                shape: "square"
              }, n);
            })
          })
        })]
      }), !isAuthenticated && !deal.shareable && !accessToken && !clientToken && !isPublicView && /*#__PURE__*/_jsx("div", {
        className: "flex justify-center items-center h-[60vh]",
        children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, redeemNowButtonConfig), {}, {
          content: "Login to view Offer Details",
          onClick: "FUNC",
          onClickFunc: openLoginModal,
          className: redeemNowButtonConfig.className,
          config: config,
          redux: redux,
          router: router
        }))
      }), !loadingDeal && (isAuthenticated || isPublicView) && /*#__PURE__*/_jsxs("div", {
        className: "".concat(redux !== null && redux !== void 0 && redux.clientWebview || redux !== null && redux !== void 0 && redux.internalWebview ? "" : "pt-20 pb-8", " w-full lg:w-[95%] xl:w-[93%] mx-auto lg:pt-0 lg:pb-0 lg:py-8 "),
        children: [!(redux !== null && redux !== void 0 && redux.clientWebview || redux !== null && redux !== void 0 && redux.internalWebview) && /*#__PURE__*/_jsxs("div", {
          onClick: handleBackClick,
          className: "flex items-center text-primary cursor-pointer  mb-2 lg:mb-4 ",
          children: [/*#__PURE__*/_jsx(IosArrowBack, {
            className: "inline text-xl"
          }), /*#__PURE__*/_jsx("p", {
            className: "inline text-base ",
            children: "Back to listing page"
          })]
        }), faultyDeal && /*#__PURE__*/_jsx(ZeroState, {
          type: "deals",
          message: "This deal no longer exists!"
        }), !faultyDeal && (isAuthenticated || !isAuthenticated && (deal === null || deal === void 0 ? void 0 : deal.shareable) || isPublicView) && /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col lg:flex-row lg:border-b-2 ".concat(config !== null && config !== void 0 && config.darkMode ? "border-[#9b9b9b]" : "border-gray-200 ", " items-start lg:pb-7 "),
          children: [deal !== null && deal !== void 0 && (_deal$displayImage4 = deal.displayImage) !== null && _deal$displayImage4 !== void 0 && _deal$displayImage4.url && deal !== null && deal !== void 0 && deal.videoUrl || (deal === null || deal === void 0 || (_deal$additionalBanne = deal.additionalBannerImages) === null || _deal$additionalBanne === void 0 ? void 0 : _deal$additionalBanne.length) > 0 ? /*#__PURE__*/_jsxs("div", {
            className: "hidden lg:flex flex-col pr-4 max-h-[250px] md:max-h-[480px] lg:max-h-[335px] xl:max-h-[410px] 2xl:max-h-[406px] overflow-hidden",
            children: [(deal === null || deal === void 0 ? void 0 : deal.videoUrl) && /*#__PURE__*/_jsxs("div", {
              className: "flex relative w-full  justify-center",
              children: [/*#__PURE__*/_jsx(DealGalleryItem, {
                imageUrl: deal === null || deal === void 0 || (_deal$displayImage5 = deal.displayImage) === null || _deal$displayImage5 === void 0 ? void 0 : _deal$displayImage5.url,
                videoUrl: deal === null || deal === void 0 ? void 0 : deal.videoUrl,
                previewItem: previewItem,
                setPreviewItem: setPreviewItem,
                winnreAuth: winnreAuth
              }), /*#__PURE__*/_jsx(MdPlayCircleOutline, {
                className: " absolute self-center text-white text-4xl "
              })]
            }), (deal === null || deal === void 0 || (_deal$displayImage6 = deal.displayImage) === null || _deal$displayImage6 === void 0 ? void 0 : _deal$displayImage6.url) && /*#__PURE__*/_jsx(DealGalleryItem, {
              imageUrl: deal === null || deal === void 0 || (_deal$displayImage7 = deal.displayImage) === null || _deal$displayImage7 === void 0 ? void 0 : _deal$displayImage7.url,
              previewItem: previewItem,
              setPreviewItem: setPreviewItem
            }), /*#__PURE__*/_jsx("div", {
              id: "DealsDetail",
              className: "max-w-[70px] max-h-[250px] md:max-h-[480px] lg:max-h-[335px] xl:max-h-[410px] 2xl:max-h-[406px] overflow-y-scroll overflow-y-hidden overflow-x-hidden",
              children: (deal === null || deal === void 0 || (_deal$additionalBanne2 = deal.additionalBannerImages) === null || _deal$additionalBanne2 === void 0 ? void 0 : _deal$additionalBanne2.length) > 0 && (deal === null || deal === void 0 || (_deal$additionalBanne3 = deal.additionalBannerImages) === null || _deal$additionalBanne3 === void 0 ? void 0 : _deal$additionalBanne3.map(function (d) {
                return /*#__PURE__*/_jsx(DealGalleryItem, {
                  imageUrl: d === null || d === void 0 ? void 0 : d.url,
                  previewItem: previewItem,
                  setPreviewItem: setPreviewItem
                });
              }))
            })]
          }) : null, previewItem && previewItem === deal.videoUrl ? /*#__PURE__*/_jsx("div", {
            className: "relative h-[250px] md:h-[480px] lg:h-[335px] xl:h-[410px] 2xl:h-[406px] w-full ".concat(
            // deal?.redemptionType === 'CONSULTATION'
            //     ? 'lg:w-[60%]' :
            "lg:w-[50%]"),
            children: /*#__PURE__*/_jsx(ReactPlayer, {
              url: previewItem,
              className: "react-player absolute self-center !h-[90%]",
              playIcon: /*#__PURE__*/_jsxs("div", {
                className: "flex relative w-full mt-10 justify-center ",
                children: [/*#__PURE__*/_jsx("img", {
                  className: "object-contain  w-full brightness-75",
                  src: deal === null || deal === void 0 || (_deal$displayImage8 = deal.displayImage) === null || _deal$displayImage8 === void 0 ? void 0 : _deal$displayImage8.url
                }), /*#__PURE__*/_jsx(EiPlay, {
                  className: " absolute self-center text-white text-9xl "
                })]
              }),
              playing: playVideo,
              light: true,
              onClickPreview: function onClickPreview() {
                setPlayVideo(true);
              },
              width: "100%",
              height: "100%",
              controls: true
            })
          }) : /*#__PURE__*/_jsxs("div", {
            className: "relative w-full lg:w-[45%] lg:sticky lg:top-0 lg:max-h-screen lg:overflow-y-auto",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-full flex justify-center",
              children: /*#__PURE__*/_jsx("img", {
                src: previewItem,
                className: "w-auto max-w-full h-auto max-h-[90vh] object-contain object-top",
                alt: "Deal preview",
                style: {
                  minHeight: "50vh"
                }
              })
            }), clientWebview && /*#__PURE__*/_jsx("div", {
              onClick: function onClick() {
                return history.goBack();
              },
              className: "absolute  flex justify-center items-center top-2 left-2 rounded-full h-10 w-10 bg-[#ffffffb3]",
              children: /*#__PURE__*/_jsx(BsArrowLeft, {
                className: "text-black w-6 h-full"
              })
            }), !copiedText && deal.redemptionType !== "CONTACT" && !showModal && isExternalDeal && /*#__PURE__*/_jsx("div", {
              className: "".concat(internalWebview ? " px-3 py-2 bg-white" : "", " fixed lg:static bottom-0 left-0 right-0 w-full lg:w-full z-30 lg:z-0"),
              style: internalWebview ? {
                zIndex: 1000,
                position: "fixed",
                bottom: "0"
              } : {},
              children: /*#__PURE__*/_jsx("div", {
                className: "".concat(internalWebview ? " flex justify-center" : "", " w-full lg:w-full "),
                children: /*#__PURE__*/_jsx(RedeemAnimation, {
                  content: deal.ctaText,
                  onClick: function onClick() {
                    if (!termsCheckbox) {
                      setShowTnCWarning(true); // Show warning if TnC not checked
                      return;
                    }
                    redeemNowClickedHandler(deal.url, deal.id, deal === null || deal === void 0 ? void 0 : deal.redemptionType);
                  },
                  disabled: rememptionLoading,
                  fullWidth: true,
                  config: config,
                  redux: redux
                })
              })
            })]
          }), deal !== null && deal !== void 0 && (_deal$displayImage9 = deal.displayImage) !== null && _deal$displayImage9 !== void 0 && _deal$displayImage9.url && deal !== null && deal !== void 0 && deal.videoUrl || (deal === null || deal === void 0 || (_deal$additionalBanne4 = deal.additionalBannerImages) === null || _deal$additionalBanne4 === void 0 ? void 0 : _deal$additionalBanne4.length) > 0 ? /*#__PURE__*/_jsxs("div", {
            id: "DealsDetail",
            className: "flex flex-row lg:hidden mt-2 overflow-x-scroll max-w-[100%]",
            children: [(deal === null || deal === void 0 ? void 0 : deal.videoUrl) && /*#__PURE__*/_jsxs("div", {
              className: "flex relative w-full justify-center",
              children: [/*#__PURE__*/_jsx(DealGalleryItem, {
                imageUrl: deal === null || deal === void 0 || (_deal$displayImage0 = deal.displayImage) === null || _deal$displayImage0 === void 0 ? void 0 : _deal$displayImage0.url,
                videoUrl: deal === null || deal === void 0 ? void 0 : deal.videoUrl,
                previewItem: previewItem,
                setPreviewItem: setPreviewItem
              }), /*#__PURE__*/_jsx(MdPlayCircleOutline, {
                className: " absolute self-center text-white text-4xl "
              })]
            }), (deal === null || deal === void 0 || (_deal$displayImage1 = deal.displayImage) === null || _deal$displayImage1 === void 0 ? void 0 : _deal$displayImage1.url) && /*#__PURE__*/_jsx(DealGalleryItem, {
              imageUrl: deal === null || deal === void 0 || (_deal$displayImage10 = deal.displayImage) === null || _deal$displayImage10 === void 0 ? void 0 : _deal$displayImage10.url,
              previewItem: previewItem,
              setPreviewItem: setPreviewItem
            }), (deal === null || deal === void 0 || (_deal$additionalBanne5 = deal.additionalBannerImages) === null || _deal$additionalBanne5 === void 0 ? void 0 : _deal$additionalBanne5.length) > 0 && (deal === null || deal === void 0 || (_deal$additionalBanne6 = deal.additionalBannerImages) === null || _deal$additionalBanne6 === void 0 ? void 0 : _deal$additionalBanne6.map(function (d) {
              return /*#__PURE__*/_jsx(DealGalleryItem, {
                imageUrl: d === null || d === void 0 ? void 0 : d.url,
                previewItem: previewItem,
                setPreviewItem: setPreviewItem
              });
            }))]
          }) : null, /*#__PURE__*/_jsxs("div", {
            className: "w-[93%] mx-auto lg:w-[50%] lg:pl-7 h-full ",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex flex-col ",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex items-center justify-between mt-3 lg:mt-0",
                children: [!isExternalDeal && !isRewards && /*#__PURE__*/_jsx("p", {
                  className: "text-primary uppercase font-bold text-sm ",
                  children: deal === null || deal === void 0 || (_deal$vendor4 = deal.vendor) === null || _deal$vendor4 === void 0 ? void 0 : _deal$vendor4.name
                }), isRewards && /*#__PURE__*/_jsx("p", {
                  className: "text-primary uppercase font-bold text-sm ",
                  children: deal === null || deal === void 0 || (_deal$brand = deal.brand) === null || _deal$brand === void 0 ? void 0 : _deal$brand.name
                }), showShare && deal.shareable && !isRewards && /*#__PURE__*/_jsxs("div", {
                  className: "flex ml-2",
                  children: [/*#__PURE__*/_jsx("button", {
                    className: "",
                    title: "Click to share",
                    onClick: handleShareClick,
                    children: /*#__PURE__*/_jsxs("div", {
                      className: "flex flex-row items-center gap-1 sm:gap-2",
                      children: [/*#__PURE__*/_jsx(EnShareAlternative, {
                        className: "h-4 w-4 md:h-5 md:w-5"
                      }), /*#__PURE__*/_jsx("p", {
                        className: "z-10 text-sm font-semibold capitalize  font-sans cursor-pointer",
                        children: "Share"
                      })]
                    })
                  }), " "]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: " flex flex-col justify-center ",
                children: [/*#__PURE__*/_jsx("h1", {
                  className: "".concat(config !== null && config !== void 0 && config.darkMode ? "text-base-content" : "text-black ", " ").concat(isExternalDeal ? "mt-1" : "mt-3 lg:mt-3", " medium text-2xl xl:text-3xl  font-semibold border-b-2 ").concat(config !== null && config !== void 0 && config.darkMode ? "border-[#9b9b9b]" : "border-gray-200 ", " pb-3 "),
                  children: deal === null || deal === void 0 ? void 0 : deal.title
                }), !isRewards && (deal === null || deal === void 0 ? void 0 : deal.couponId) <= 0 && /*#__PURE__*/_jsx(DealValidity, {
                  date: deal === null || deal === void 0 ? void 0 : deal.endDate,
                  removeTopMargin: (deal === null || deal === void 0 ? void 0 : deal.couponId) > 0
                }), isPoints && /*#__PURE__*/_jsxs("div", {
                  className: "flex  items-center gap-2 mt-2",
                  children: [/*#__PURE__*/_jsx(Coin, {}), /*#__PURE__*/_jsx("h3", {
                    className: "font-medium text-gray-500",
                    children: formattedDealPoints
                  })]
                }), isRewards && !isPoints && /*#__PURE__*/_jsx("div", {
                  "class": "flex  items-center gap-4 mt-2",
                  children: /*#__PURE__*/_jsxs("h3", {
                    className: "text-sm font-medium text-gray-500 line-through",
                    children: ["MRP", " ", /*#__PURE__*/_jsx("span", {
                      className: "",
                      children: toIndianRs(deal === null || deal === void 0 ? void 0 : deal.productMrp)
                    })]
                  })
                })]
              })]
            }), (deal === null || deal === void 0 ? void 0 : deal.termsAndConditions) && isRewards && /*#__PURE__*/_jsx(TnC, {
              handleOnChange: handleOnChange,
              termsCheckbox: termsCheckbox,
              handleTnC: handleTnC,
              config: config
            }), isRewards && /*#__PURE__*/_jsx("button", {
              className: " mx-auto text-primary text-center text-sm font-semibold",
              onClick: function onClick() {
                return window.open(deal === null || deal === void 0 ? void 0 : deal.url);
              },
              title: "Compare with ".concat(deal === null || deal === void 0 || (_deal$vendor5 = deal.vendor) === null || _deal$vendor5 === void 0 ? void 0 : _deal$vendor5.name),
              children: "Compare the product"
            }), isRewards && !isPublicView && /*#__PURE__*/_jsxs("div", {
              className: "flex items-center gap-5 z-[99] lg:z-0 border-t-[1px]  lg:border-t-[0px]  border-color-[#dddd] left-0 right-0 bottom-0 w-full fixed lg:static px-[15px] lg:px-0 py-[10px] ".concat(itemAdded ? "px-3" : "bg-white"),
              children: [/*#__PURE__*/_jsxs("button", {
                onClick: function onClick() {
                  if (!termsCheckbox) {
                    setShowTnCWarning(true); // Show warning if TnC not checked
                    return; // Prevent further actions
                  }
                  handleCheckOut(true);
                },
                className: "".concat((deal === null || deal === void 0 ? void 0 : deal.points) > totalRewardspoint || disableCart ? "opacity-50 cursor-not-allowed" : "", " rounded-md w-[50%] p-[15px]  px-[5px] lg:px-[15px]  lg:w-auto text-center bg-primary flex items-center justify-center   text-white font-normal  text-sm "),
                disabled: (deal === null || deal === void 0 ? void 0 : deal.points) > totalRewardspoint || disableCart,
                children: [BuyNowSvg, " Buy Now"]
              }), /*#__PURE__*/_jsx(_Fragment, {
                children: (deal === null || deal === void 0 ? void 0 : deal.points) > totalRewardspoint || disableCart ? /*#__PURE__*/_jsx("button", {
                  onClick: function onClick() {
                    return history.push(totalRewardspoint > 0 ? handleCheckOut(false) : "/gift-and-earn");
                  },
                  className: "flex  w-[50%]   p-[15px]  px-[5px] lg:px-[15px]  lg:w-auto items-center gap-2 border justify-center border-primary font-normal text-primary rounded-md transition   text-sm",
                  children: /*#__PURE__*/_jsx("span", {
                    children: totalRewardspoint > 0 ? "Checkout" : "Refer now"
                  })
                }) : /*#__PURE__*/_jsx("button", {
                  onClick: function onClick(event) {
                    event.stopPropagation(); // Prevent event bubbling
                    if (!termsCheckbox) {
                      setShowTnCWarning(true); // Show warning if TnC not checked
                      return;
                    }
                    if (!itemAdded) OnCartClick(true); // Call only if the button is not already clicked
                  },
                  disabled: (deal === null || deal === void 0 ? void 0 : deal.points) > totalRewardspoint || disableCart || itemAdded,
                  className: "".concat(itemAdded ? "bg-gray-200" : "bg-gray-50", " flex  w-[50%]  p-[15px]  px-[5px] lg:px-[15px] lg:w-auto items-center gap-2 border justify-center border-primary font-normal text-primary rounded-md transition   text-sm"),
                  children: /*#__PURE__*/_jsxs(_Fragment, {
                    children: [/*#__PURE__*/_jsx("div", {
                      id: "main-tick",
                      className: "".concat(itemAdded ? "w-[14px]" : "w-[0px]"),
                      children: /*#__PURE__*/_jsx("div", {
                        className: "".concat(itemAdded ? "   tick-animation active" : "", " tick-animation overflow-hidden "),
                        children: /*#__PURE__*/_jsx("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "14",
                          height: "10.2",
                          viewBox: "0 0 14 10.2",
                          children: /*#__PURE__*/_jsx("path", {
                            id: "check",
                            d: "M18.7,7.2a.967.967,0,0,0-1.4,0L9.8,14.7,6.7,11.6A.99.99,0,0,0,5.3,13l3.8,3.8a.967.967,0,0,0,1.4,0l8.2-8.2a.967.967,0,0,0,0-1.4Z",
                            transform: "translate(-5 -6.9)",
                            fill: "#4652a4"
                          })
                        })
                      })
                    }), !itemAdded && /*#__PURE__*/_jsx("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "13.054",
                      height: "15.067",
                      viewBox: "0 0 13.054 15.067",
                      children: /*#__PURE__*/_jsxs("g", {
                        id: "bag",
                        transform: "translate(-3.005 -0.995)",
                        children: [/*#__PURE__*/_jsx("path", {
                          id: "Path_7734",
                          "data-name": "Path 7734",
                          d: "M16.056,13.1l-.91-8.743a1.5,1.5,0,0,0-1.5-1.351H11.991a2.511,2.511,0,0,0-4.921,0H5.413a1.5,1.5,0,0,0-1.5,1.35L3,13.1v.05a2.916,2.916,0,0,0,2.91,2.913h7.231a2.916,2.916,0,0,0,2.913-2.913A.446.446,0,0,0,16.056,13.1ZM9.531,2a1.509,1.509,0,0,1,1.421,1H8.11A1.509,1.509,0,0,1,9.531,2Zm3.616,13.056H5.915a1.908,1.908,0,0,1-1.908-1.884l.908-8.712a.5.5,0,0,1,.5-.452h8.235a.5.5,0,0,1,.5.452l.9,8.712a1.908,1.908,0,0,1-1.908,1.884Z",
                          fill: "#4652a4"
                        }), /*#__PURE__*/_jsx("path", {
                          id: "Path_7735",
                          "data-name": "Path 7735",
                          d: "M15.519,11a.5.5,0,0,0-.5.5A1.506,1.506,0,1,1,12,11.5a.5.5,0,0,0-1,0,2.511,2.511,0,1,0,5.022,0A.5.5,0,0,0,15.519,11Z",
                          transform: "translate(-3.98 -4.981)",
                          fill: "#4652a4"
                        })]
                      })
                    }), itemAdded ? /*#__PURE__*/_jsx("span", {
                      children: "Added to Gift Basket"
                    }) : /*#__PURE__*/_jsx("span", {
                      children: "Add to Gift Basket"
                    })]
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Description, {
              content: deal === null || deal === void 0 ? void 0 : deal.description,
              title: "Description",
              isRewards: true,
              date: deal === null || deal === void 0 ? void 0 : deal.endDate,
              removeTopMargin: isExternalDeal
            }), isRewards && /*#__PURE__*/_jsx("div", {
              className: "w-full mx-auto",
              children: /*#__PURE__*/_jsx(Description, {
                isRewards: isRewards,
                content: productSpecifications,
                title: "Key Features"
              })
            }), !isRewards && isExternalDeal && /*#__PURE__*/_jsx(DealValidity, {
              date: deal === null || deal === void 0 ? void 0 : deal.endDate,
              removeTopMargin: isExternalDeal
            }), !isRewards && !isExternalDeal && /*#__PURE__*/_jsxs("div", {
              className: "flex items-center lg:border-b-2 ".concat(config !== null && config !== void 0 && config.darkMode ? "lg:border-[#9b9b9b]" : "lg:border-gray-200 ", "  lg:border-0  lg:pb-4 w-full ").concat(internalWebview ? " mt-2 md:mt-3  pb-3" : "mt-4 lg:pb-6"),
              children: [deal.redemptionType === "CONTACT" && /*#__PURE__*/_jsx("a", {
                className: "w-[100%]",
                href: "tel:".concat(deal === null || deal === void 0 || (_deal$vendor6 = deal.vendor) === null || _deal$vendor6 === void 0 ? void 0 : _deal$vendor6.contactNumber),
                children: /*#__PURE__*/_jsx(RedeemAnimation, {
                  content: deal.ctaText,
                  onClick: function onClick() {
                    if (!termsCheckbox) {
                      setShowTnCWarning(true); // Show warning if TnC not checked
                      return;
                    }
                    redeemNowClickedHandler(deal.url, deal.id, deal === null || deal === void 0 ? void 0 : deal.redemptionType);
                  },
                  disabled:
                  // !termsCheckbox ||
                  rememptionLoading,
                  config: config,
                  redux: redux
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex flex-col lg:flex-row w-full",
                children: [/*#__PURE__*/_jsx("div", {}), !copiedText && deal.redemptionType !== "CONTACT" && !showModal && /*#__PURE__*/_jsx("div", {
                  className: "".concat(internalWebview ? " px-3 py-2 bg-white" : "", " fixed lg:static bottom-0 left-0 right-0 w-full lg:w-auto z-30 lg:z-0"),
                  style: internalWebview ? {
                    zIndex: 1000,
                    position: "fixed",
                    bottom: "0"
                  } : {},
                  children: /*#__PURE__*/_jsx("div", {
                    className: "".concat(internalWebview ? " flex justify-center" : "", " w-full lg:w-auto ")
                    //  style={internalWebview ? { zIndex: 1000 ,  position: 'fixed', bottom: '0'  } : {}}
                    ,
                    children: /*#__PURE__*/_jsx(RedeemAnimation, {
                      content: deal.ctaText,
                      onClick: function onClick() {
                        if (!termsCheckbox) {
                          setShowTnCWarning(true); // Show warning if TnC not checked
                          return;
                        }
                        redeemNowClickedHandler(deal.url, deal.id, deal === null || deal === void 0 ? void 0 : deal.redemptionType);
                      },
                      disabled:
                      // !termsCheckbox ||
                      rememptionLoading,
                      config: config,
                      redux: redux
                    })
                  })
                }), showShareModal && /*#__PURE__*/_jsx(Modal, {
                  visible: showShareModal,
                  showButton: true,
                  showCloseButton: false,
                  onClick: function onClick() {
                    return setShowShareModal(false);
                  },
                  children: /*#__PURE__*/_jsx("div", {
                    className: "flex flex-col px-5 ",
                    children: /*#__PURE__*/_jsxs(_Fragment, {
                      children: [/*#__PURE__*/_jsxs("div", {
                        className: "flex justify-between items-center my-4 ",
                        children: [/*#__PURE__*/_jsx("h1", {
                          className: " text-lg sm:text-xl font-bold ",
                          children: "Share this Deal"
                        }), /*#__PURE__*/_jsx(EiCloseO, {
                          onClick: function onClick() {
                            return setShowShareModal(false);
                          },
                          className: " h-7 w-7 sm:h-9 sm:w-10 cursor-pointer   text-gray-500"
                        })]
                      }), /*#__PURE__*/_jsxs("svg", {
                        viewBox: "0 0 457 2",
                        children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("g", {
                          id: "Layer_2",
                          "data-name": "Layer 2",
                          children: /*#__PURE__*/_jsx("g", {
                            id: "Layer_1-2",
                            "data-name": "Layer 1",
                            children: /*#__PURE__*/_jsx("polygon", {
                              "class": "cls-1",
                              points: "0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1",
                              fill: "#e5e5e5"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "flex gap-5 items-center my-5",
                        children: [/*#__PURE__*/_jsx("img", {
                          variant: "square",
                          loading: "lazy",
                          className: "".concat(config !== null && config !== void 0 && (_config$projects$modu = config.projects.moduleConfig) !== null && _config$projects$modu !== void 0 && _config$projects$modu.QRCodeImage ? "h-10 w-10" : "h-20 w-28", " z-10  object-center object-cover rounded-lg"),
                          src: (_deal$vendor7 = deal.vendor) === null || _deal$vendor7 === void 0 || (_deal$vendor7 = _deal$vendor7.logo) === null || _deal$vendor7 === void 0 ? void 0 : _deal$vendor7.url,
                          alt: "property"
                        }), /*#__PURE__*/_jsxs("div", {
                          className: "flex flex-col ",
                          children: [/*#__PURE__*/_jsx("p", {
                            className: "text-black font-semibold text-base sm:text-lg",
                            children: deal === null || deal === void 0 ? void 0 : deal.title
                          }), /*#__PURE__*/_jsxs("p", {
                            className: "text-[#908F95] text-sm sm:text-base italic",
                            children: [" ", "Valid upto :", " ", renderDate(deal === null || deal === void 0 ? void 0 : deal.endDate)]
                          })]
                        })]
                      }), /*#__PURE__*/_jsxs("svg", {
                        viewBox: "0 0 457 2",
                        children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("g", {
                          id: "Layer_2",
                          "data-name": "Layer 2",
                          children: /*#__PURE__*/_jsx("g", {
                            id: "Layer_1-2",
                            "data-name": "Layer 1",
                            children: /*#__PURE__*/_jsx("polygon", {
                              "class": "cls-1",
                              points: "0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1",
                              fill: "#e5e5e5"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "flex flex-wrap justify-between items-center mt-5 ",
                        children: [/*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%]  md:w-[45%]  cursor-pointer  flex gap-2  border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsxs("button", {
                            title: copiedUrl ? "Link copied" : "Click to copy",
                            className: "",
                            onClick: function onClick() {
                              return copyDealHandler();
                            },
                            children: [!copiedUrl && /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx(FiCopy, {
                                className: "cursor-pointer w-5 h-full"
                              }), /*#__PURE__*/_jsx("p", {
                                className: "font-bold text-sm sm:text-base",
                                children: "Link Copy"
                              })]
                            }), copiedUrl && /*#__PURE__*/_jsx("p", {
                              className: "mx-auto px-6 self-center  rounded-lg text-center font-normal animate-pulse bg-white text-xs sm:text-sm   text-[#006EB7] ",
                              children: "Link Copied"
                            })]
                          })
                        }), /*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%] md:w-[45%]  cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsx(EmailShareButton, {
                            url: userRole === "CUSTOMER" ? shareLink : window.location.href,
                            body: deal.shareMessage ? deal.shareMessage : "Hello! Hope you're doing well. I wanted to share this exciting deal I found recently. Here's the link: 🏘️ Click to learn more!",
                            subject: deal.shareMessage ? deal.shareMessage : "Hello! I wanted to share this exciting deal I found recently. Here's the link: 🏘️ Click to learn more!",
                            children: /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx(MdcEmailOutline, {
                                className: "w-5 h-full"
                              }), /*#__PURE__*/_jsx("p", {
                                className: "  font-bold text-sm sm:text-base",
                                children: "Email"
                              })]
                            })
                          })
                        }), /*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%]  md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsx(WhatsappShareButton, {
                            url: userRole === "CUSTOMER" ? shareLink : window.location.href,
                            title: deal.shareMessage ? deal.shareMessage : "Hello! Hope you're doing well. I wanted to share this exciting deal I found recently. Here's the link: 🏘️ Click to learn more!",
                            children: /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx(SiWhatsapp, {
                                className: "w-5 h-full"
                              }), /*#__PURE__*/_jsx("p", {
                                className: "  font-bold text-sm sm:text-base ",
                                children: "WhatsApp"
                              })]
                            })
                          })
                        }), /*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%]  md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsx(FacebookShareButton, {
                            url: userRole === "CUSTOMER" ? shareLink : window.location.href,
                            title: deal.shareMessage ? deal.shareMessage : "Hey friends! Just stumbled upon this incredible deal that I couldn't wait to share with you all. Take a look: 🌟 Click on the below link to explore further!",
                            children: /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx(FaFacebookF, {
                                className: "w-5 h-full"
                              }), /*#__PURE__*/_jsx("p", {
                                className: "font-bold text-sm sm:text-base ",
                                children: "Facebook"
                              })]
                            })
                          })
                        }), /*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%]  md:w-[45%]  cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsx(TwitterShareButton, {
                            url: userRole === "CUSTOMER" ? shareLink : window.location.href,
                            title: deal.shareMessage ? deal.shareMessage : "Exciting news! Discovered a fantastic deal worth checking out. Here's the link: 🏢 Click to learn more!",
                            children: /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx("svg", {
                                size: 20,
                                className: "w-5 text-black",
                                stroke: "currentColor",
                                fill: "currentColor",
                                "stroke-width": "0",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/_jsx("path", {
                                  d: "M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z"
                                })
                              }), /*#__PURE__*/_jsx("button", {
                                className: "  font-bold text-sm sm:text-base",
                                children: "Twitter"
                              })]
                            })
                          })
                        })]
                      })]
                    })
                  })
                })]
              })]
            }), (deal === null || deal === void 0 ? void 0 : deal.termsAndConditions) && !isRewards && /*#__PURE__*/_jsx(TnC, {
              handleOnChange: handleOnChange,
              termsCheckbox: termsCheckbox,
              handleTnC: handleTnC,
              config: config
            })]
          })]
        }), isRewards && /*#__PURE__*/_jsx(RewardClaimDescription, {
          config: config
        }), !isCuratedRoute && /*#__PURE__*/_jsx("div", {
          className: "w-[93%] lg:w-full mx-auto py-5",
          children: /*#__PURE__*/_jsx(MoreOffers, {
            similarOffers: similarOffers,
            topOffers: topOffers,
            sameBrandOffers: sameBrandOffers,
            isRewards: isRewards,
            isPoints: isPoints,
            isBundleDeal: isBundleDeal,
            config: config,
            redux: {
              dispatch: dispatch,
              dealAction: redux === null || redux === void 0 ? void 0 : redux.dealAction,
              auth: redux === null || redux === void 0 || (_redux$store = redux.store) === null || _redux$store === void 0 || (_redux$store = _redux$store.getState()) === null || _redux$store === void 0 ? void 0 : _redux$store.auth,
              deals: redux === null || redux === void 0 || (_redux$store2 = redux.store) === null || _redux$store2 === void 0 || (_redux$store2 = _redux$store2.getState()) === null || _redux$store2 === void 0 ? void 0 : _redux$store2.deals
            },
            router: {
              history: history,
              location: location
            },
            cmsClient: cmsClient,
            winnreAuth: winnreAuth,
            winnreNoAuth: undefined
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(Modal, {
      className: "w-[95%] lg:w-[80%]",
      visible: showTerms,
      onClick: function onClick() {
        return setShowTerms(false);
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-end mr-4 mt-4 mb-2",
        children: /*#__PURE__*/_jsx(GrClose, {
          onClick: function onClick() {
            return setShowTerms(false);
          },
          className: " h-4 w-4 cursor-pointer self-end ml-auto"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: " text-[#373737] text-sm lg:text-base font-medium break-words leading-[1.4] p-2 lg:p-10 overflow-y-scroll h-[90vh] lg:h-auto ",
        children: [/*#__PURE__*/_jsxs("p", {
          children: ["By clicking on ", isRewards ? "Buy at" : deal.ctaText, " , you agree & authorize Reloy and", " ", isBundleDeal ? "all partner brands part of this bundle deal" : "partner brands", " ", "to call you or contact you via various communication modes to assist you with your queries. This consent will override your DNC/NDNC registration if any."]
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-5",
          dangerouslySetInnerHTML: isHTML(deal.termsAndConditions) ? {
            __html: deal.termsAndConditions
          } : {
            __html: "<p>".concat(deal.termsAndConditions, "</p>")
          }
        })]
      })]
    }), showTnCWarning && /*#__PURE__*/_jsxs(Modal, {
      className: "w-[95%] md:w-[45%] lg:w-[40%] xl:w-[30%]",
      visible: showTnCWarning,
      onClick: function onClick() {
        return setShowTnCWarning(false);
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-end mr-4 mt-4",
        children: /*#__PURE__*/_jsx(GrClose, {
          onClick: function onClick() {
            return setShowTnCWarning(false);
          },
          className: " h-4 w-4 cursor-pointer self-end ml-auto"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-center px-4 py-2",
        children: [/*#__PURE__*/_jsxs("p", {
          className: "text-[#373737] text-sm lg:text-base font-medium",
          children: ["Please accept the Terms and Conditions to continue. This step is required to ", isRewards ? "redeem your reward" : "access the deal", "."]
        }), /*#__PURE__*/_jsx("button", {
          className: "mt-4 bg-primary text-white py-2 px-4 rounded mb-2",
          onClick: function onClick() {
            return setShowTnCWarning(false);
          },
          children: "Got it"
        })]
      })]
    }), showUnregisteredModal && /*#__PURE__*/_jsxs(Modal, {
      className: "w-[95%] md:w-[55%] lg:w-[50%] xl:w-[45%]",
      visible: showUnregisteredModal,
      onClick: function onClick() {
        return setShowUnregisteredModal(false);
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-end mr-4 mt-4",
        children: /*#__PURE__*/_jsx(GrClose, {
          onClick: function onClick() {
            return setShowUnregisteredModal(false);
          },
          className: " h-4 w-4 cursor-pointer self-end ml-auto"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-left px-4 pb-8 text-black",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "font-bold text-xl",
          children: "Hello There"
        }), /*#__PURE__*/_jsx("p", {
          className: "text-sm lg:text-base font-medium mt-2",
          children: "Your registration is being reviewed."
        }), /*#__PURE__*/_jsx("p", {
          className: "text-sm lg:text-base font-medium mt-1",
          children: "Once it is approved, you will become eligible for our benefits!"
        })]
      })]
    }), showMultipleRedemption && /*#__PURE__*/_jsxs(Modal, {
      className: "w-[100%] md:w-[95%] lg:w-[50%] xl:w-[35%]",
      visible: showMultipleRedemption,
      onClick: function onClick() {
        return setShowMultipleRedemption(false);
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-end mr-4 mt-4",
        children: /*#__PURE__*/_jsx(GrClose, {
          onClick: function onClick() {
            return setShowMultipleRedemption(false);
          },
          className: "h-4 w-4 cursor-pointer self-end ml-auto"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-center px-4 pb-8",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex flex-col items-center mb-2",
          children: [/*#__PURE__*/_jsx("img", {
            className: "h-[84px] w-[84px] -mb-3",
            src: "https://htmlemailer.s3.ap-south-1.amazonaws.com/html-media/godrej/Gift-box-new.gif",
            alt: "Gift box animation"
          }), /*#__PURE__*/_jsx("p", {
            className: "font-bold text-black text-lg",
            children: "Congratulations!"
          })]
        }), /*#__PURE__*/_jsx("p", {
          className: "text-sm lg:text-base font-medium mt-1",
          children: "Thank you for redeeming this offer!"
        }), /*#__PURE__*/_jsx("p", {
          className: "mt-1 text-sm lg:text-base",
          children: "Your coupon code has been sent to your email and WhatsApp. Please present it at the venue to redeem your offer."
        })]
      })]
    }), /*#__PURE__*/_jsx(DealRedemptionModal, {
      visible: showModal,
      onClose: function onClose() {
        return setShowModal(false);
      },
      captureUserMobile: captureUserMobile,
      setCaptureUserMobile: setCaptureUserMobile,
      redeemNowClickedHandler: redeemNowClickedHandler,
      deal: deal,
      isBundleDeal: isBundleDeal,
      isVoucherDeal: isVoucherDeal,
      isCodeDeal: isCodeDeal,
      isOnlineDeal: isOnlineDeal,
      voucherCode: voucherCode,
      copiedText: copiedText,
      handleCopyCode: handleCopyCode,
      config: config,
      modalMessage: modalMessage,
      isOfflineDeal: isOfflineDeal,
      redemptionId: redemptionId,
      prefilledData: prefilledData,
      isOfflineTag: isOfflineTag,
      history: history
    }), showSurvey && !isRewards && /*#__PURE__*/_jsx(MiniSurvey, {
      handleCloseSurvey: handleCloseSurvey,
      showSurvey: showSurvey,
      config: config,
      winnreAuth: winnreAuth
    }), isRewards && showRewardsModal && /*#__PURE__*/_jsx(RewardsPopupModal, {
      redux: {
        dispatch: dispatch,
        dealAction: redux === null || redux === void 0 ? void 0 : redux.dealAction,
        showRewardsModal: showRewardsModal
      },
      router: {
        history: history
      },
      isPoints: isPoints
    }), isRewards && openKYCModal && /*#__PURE__*/_jsx(KYCModal, {
      visible: openKYCModal,
      onClick: closeKYCModal,
      userAccountSummary: userAccountSummary,
      getUserAccountSummary: getUserAccountSummary,
      setOpenKYCModal: setOpenKYCModal,
      closeKYCModal: closeKYCModal,
      step: step,
      setStep: setStep,
      checkKycVerificationStatus: checkKycVerificationStatus,
      loading: loading,
      checkBankVerificationStatus: checkBankVerificationStatus,
      isUpdateWorkflow: isUpdateWorkflow,
      isKycCompleted: isKycCompleted,
      initiateWorkflow: initiateWorkflow,
      claimInProgress: claimInProgress,
      rewardTypeSelected: rewardTypeSelected,
      setClaimInProgress: setClaimInProgress,
      cashOutFlow: cashOutFlow,
      bankstatus: bankstatus,
      isKycFailed: isKycFailed,
      isBankVerificationFailed: isBankVerificationFailed,
      isKycProcessing: isKycProcessing,
      router: router,
      config: config,
      winnreAuth: winnreAuth,
      winnreNoAuth: winnreNoAuth,
      redux: redux,
      cmsClient: cmsClient,
      isPoints: isPoints
    }), /*#__PURE__*/_jsx(Modal, {
      visible: itemAdded,
      onClick: function onClick() {
        return setItemAdded(false);
      },
      className: "w-[85%] lg:w-[25%] xl:w-[18%] rounded-xl lg:block hidden",
      children: /*#__PURE__*/_jsxs("div", {
        className: " bg-white  flex flex-col items-center justify-center rounded-3xl py-2",
        children: [/*#__PURE__*/_jsx("div", {
          className: "absolute -top-10 z-10 ",
          children: TickSvg
        }), /*#__PURE__*/_jsxs("div", {
          className: " flex flex-col justify-center items-center  font-semibold pt-11 pb-5 gap-2",
          children: [/*#__PURE__*/_jsx("h2", {
            className: "text-2xl mt-2 text-bold",
            children: "Amazing!"
          }), /*#__PURE__*/_jsxs("p", {
            className: "text-center",
            children: [" ", "Fill your cart and gift yourself the happiness!"]
          }), /*#__PURE__*/_jsx("button", {
            "class": "px-4 py-2  text-white bg-primary rounded-lg mt-2 font-semibold ",
            onClick: function onClick() {
              return history.push(isPoints ? "/rewardpointstore" : "/rewardStore");
            },
            children: "Grab More Rewards"
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(Fireworks, {
      itemAdded: itemAdded,
      redux: redux,
      isPoints: isPoints
    }), /*#__PURE__*/_jsx(SideModal, {
      visible: itemAdded,
      onClick: function onClick() {
        return setItemAdded(false);
      },
      className: "w-full top-[68%] rounded-t-2xl lg:hidden mx-auto px-3 z-[99999]",
      config: config,
      children: /*#__PURE__*/_jsxs("div", {
        className: " bg-white  flex flex-col items-center justify-center rounded-3xl py-2",
        children: [/*#__PURE__*/_jsx("div", {
          className: "absolute -top-10 z-10 ",
          children: TickSvg
        }), /*#__PURE__*/_jsxs("div", {
          className: " flex flex-col justify-center items-center  font-semibold pt-11 gap-2",
          children: [/*#__PURE__*/_jsx("h2", {
            className: "text-2xl mt-2 text-bold",
            children: "Amazing!"
          }), /*#__PURE__*/_jsxs("p", {
            className: "text-center mt-2",
            children: [" ", "Fill your cart and gift yourself the happiness!"]
          }), /*#__PURE__*/_jsx("button", {
            "class": "px-4 py-2  text-white bg-primary rounded-lg mt-2 font-semibold ",
            onClick: function onClick() {
              return history.push(isPoints ? "/rewardpointstore" : "/rewardStore");
            },
            children: "Grab More Rewards"
          })]
        })]
      })
    })]
  });
}
export default DealDetails;